<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="User"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ ('User & Admin') }}
                    </div>
                </template>
                <template #right>
                    <div class="p-card-title" style="margin-top:10px;">
                        <!-- <Button type="button" class="p-button-warning p-button-sm" label="Export" @click="exportExcel()"
                            icon="pi pi-file-excel" />
                        <Button v-show="canUpload" label="Upload User" icon="pi pi-upload"
                            class="p-button-success p-button-sm" @click="importFileUser()" style="margin-left:5px;" />
                        <Button v-show="canUpload" label="Upload Admin" icon="pi pi-upload"
                            class="p-button-success p-button-sm" @click="importFileAdmin()" style="margin-left:5px;"
                            v-if="this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || this.$store.getters.getIsAdmin" /> -->
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort stateStorage="local" :stateKey="stateKey" :value="dataModel" :loading="!dataModel || loading"
                :paginator="true" :rows="10" :lazy="true" v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                @state-restore="onStateRestore($event)" @page="onPage($event)" @sort="onSort($event)"
                @filter="onFilter($event)" v-model:filters="filters" :totalRecords="totalRecords" :rowClass="rowClass" dataKey="Id" id="main"> 
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #header>
                        <Button v-show="canCreate" :label="$t('create')" icon="pi pi-plus"
                            class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" />
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView" class="p-button-rounded p-button-info mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_VIEW, dataModel.data.Id)" />
                        <Button icon="pi pi-pencil" v-show="canEdit && dataModel.data.Is_Deleted == 'N' && ( dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED) && (dataModel.data.Active == false || dataModel.data.Active == true || dataModel.data.Status == this.$REQUEST_STATUS.DRAFT || dataModel.data.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION)"
                            class="p-button-rounded p-button-success mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id)" />
                        <Button icon="pi pi-trash" v-show="canDelete && dataModel.data.Is_Deleted == 'N' && ( dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED)"
                            class="p-button-rounded p-button-danger mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_DELETE, dataModel.data.Id)" />
                    </template>
                </Column>

                <Column field="Status" :header="$t('status')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('status')" />   
                    </template>
                    <template #body="{ data }">
                        <span v-if="(data.Status == this.$APPROVAL_STATUS.REJECTED || data.Status == this.$APPROVAL_STATUS.APPROVED) && data.Active == false" style="color: red;"> {{ data.Status }} </span>
                        <span v-else > {{ data.Status }} </span>
                    </template>
                </Column>
                
                <Column field="Active" :header="$t('active')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('active')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        <span v-if="(data.Status == this.$APPROVAL_STATUS.REJECTED || data.Status == this.$APPROVAL_STATUS.APPROVED) && data.Active == false" style="color: red;"> {{ data.Active ? "Y" : "N" }} </span>
                        <span v-else > {{ data.Active ? "Y" : "N" }} </span>
                    </template>
                </Column>
                
                <Column field="Employee_Number" :header="$t('username')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('emp_number')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Full_Name" :header="$t('full_name')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('full_name')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="User_Type" :header="$t('user_type')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('user_type')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <!-- <Column field="PIC_Name" :header="$t('pic')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('pic')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
                <Column field="Use_AD" :header="$t('use_ad')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('use_ad')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ data.Use_AD ? "Y" : "N" }}
                    </template>
                </Column>
                
                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()"/>
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('created_by')" />
                    </template>
                </Column>
                <Column field="Edited_Date" :header="$t('edited_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" @date-select="filterCallback()" :placeholder="$t('edited_date')" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Edited_Date) }}
                    </template>
                </Column>
                <Column field="Edited_By" :header="$t('edited_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edited_by')" />
                    </template>
                </Column>
                <Column field="Is_Deleted" :header="$t('is_deleted')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('is_deleted')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                </Column>
                <Column field="Deleted_Date" :header="$t('deleted_date')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" @date-select="filterCallback()" :placeholder="$t('deleted_date')" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Deleted_Date) }}
                    </template>
                </Column>
                <Column field="Deleted_By" :header="$t('deleted_by')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('deleted_by')" />
                    </template>
                </Column>
            </DataTable>
        </template>
        <div v-html="this.reportTbl.content" v-if="this.excelTbl" v-show="false" />
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "User",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'user-' + this.$store.getters.getUsername,
            role: this.$store.getters.getRole,
            isAdmin: this.$store.getters.getIsAdmin,
            isUser: this.$store.getters.getIsUser,
            isTransporter: this.$store.getters.getIsTransporter,
            isDriver: this.$store.getters.getIsDriver,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/User/Editor",
            dataUrl: "user/list",
            uploadPathUser: "/Helper/UploadData/User",
            uploadPathAdmin: "/Helper/UploadData/Admin",
            exportUrl: "User/export",
            excelTbl: null,
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            canUpload: false,
            pageSize : 10
        }
    },
    methods: {
        rowClass(data) {
            // return [{ 'bg-yellow-500': data.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL },
            //         { 'disabled-column': data.Status == this.$APPROVAL_STATUS.APPROVED },
            //         { 'rejecdet': data.Status == this.$APPROVAL_STATUS.REJECTED },
            //         {'delete':data.Is_Deleted == "Y"},
            //         {'draft' : data.Status == this.$REQUEST_STATUS.DRAFT}
            //     ];
        },
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
            this.canUpload = event.canUpload;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        editor(mode, id) {
            this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize : this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 3000 });
                    }
                })
                .catch(function (err) {
                    const errorMsg = err.isTimeout ? err.message : err.message;
                    self.$toast.add({ severity: 'error', summary: "Error", detail: errorMsg, life: 3000 });
                })
                .finally(() => {
                    self.loading = false;
                });
        },
        setFilters() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.stateFilters = event.filters;
            this.pageSize = event.rows;
            this.sorts = event.multiSortMeta;
        },
        editOrder() {
            this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        importFileUser() {
            this.$router.push({ path: this.uploadPathUser });
        },
        importFileAdmin() {
            this.$router.push({ path: this.uploadPathAdmin });
        },
        exportExcel() {
            this.$axios.post(this.$API_URL + this.exportUrl, this.dataModel)
                .then((response) => {
                    this.excelTbl = {
                        header: response.data.data.header,
                        content: response.data.data.content,
                        title: response.data.data.title,
                    };

                    this.tableToExcel();
                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                });
        },
        tableToExcel() {
            var uri = "data:application/vnd.ms-excel;base64,",
                template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                },
                format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };
            var ctx = {
                worksheet: "Default" || "Worksheet",
                table: this.excelTbl.header + this.excelTbl.content,
            };
            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.excelTbl.title + "_" + currentDate;
            const link = document.createElement("a");
            link.href = uri + base64(format(template, ctx));
            link.download = fileName;
            link.click();
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters();
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        }
    },
}
</script>

<style #scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>
<style>
#main .delete{
    background-color: rgb(193, 189, 189);
}
#main .draft{
    background-color: rgb(177, 189, 156);
}
#main .rejecdet{
    background-color: rgb(249, 81, 81);
}
</style>